import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import CheckoutCard from './CheckoutCard';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import { useAccessCheckoutContext } from 'screens/AccessExpressV3/context/AccessCheckoutProvider';
import { getTotalQuantity } from 'screens/AccessExpressV3/utils';

const CheckoutBody = observer(() => {
  const cart = useCartContext();

  const { locations, currentIndex } = useAccessCheckoutContext();

  const currentLocation = useMemo(
    () => locations.filter((loc) => loc.id !== undefined)?.[currentIndex], // 'new'
    [currentIndex, locations],
  );

  const items =
    currentLocation?.id !== undefined
      ? cart.primaryItemsByLocation(currentLocation.id)
      : cart.unassignedPrimaryMobilityItems;

  const totalQuantity = getTotalQuantity(items);

  return (
    <>
      <CheckoutCard
        items={items}
        total={totalQuantity}
        // subtotal={`$${cart.subTotal}`}
        // savings="$75.00"
        // discount="-$25.00"
        // taxes="$24.50"
        // shipping="$5.00"
      />
    </>
  );
});

export default CheckoutBody;
